export default "__VITE_ASSET__b$8uxdlF__"